import { EHealthProceduresTypes, IHealthProcedures, IPregnancy, ITimelineMaternalInfant } from '~/interfaces'
import { message } from '~/services'
import { getTimestamp } from '~/utils'

export * from './mappers/mapperToTimelineViewByDays'
export * from './mappers/mapperToTimelineViewByTrimester'

export const getGestationRangeBy = (gestation: IPregnancy): [Date, Date] => {
  const { startDate, endDate } = gestation
  return [new Date(startDate), new Date(endDate)]
}

export const getPuerperiumRangeBy = (gestation: IPregnancy): [Date, Date] => {
  const { endDate } = gestation
  const puerperiumEndDate = new Date(endDate).setDate(new Date(endDate).getDate() + 60)
  return [new Date(endDate), new Date(puerperiumEndDate)]
}

export const getNeonateRangeBy = (gestation: IPregnancy): [Date, Date] => {
  const { endDate } = gestation
  const neonateEndDate = new Date(endDate).setDate(new Date(endDate).getDate() + 28)
  return [new Date(endDate), new Date(neonateEndDate)]
}

export const getInfantRangeBy = (gestation: IPregnancy): [Date, Date] => {
  const { endDate } = gestation
  const infantStartDate = new Date(endDate).setDate(new Date(endDate).getDate() + 29)
  const infantEndDate = new Date(endDate).setFullYear(new Date(endDate).getFullYear() + 2)
  return [new Date(infantStartDate), new Date(infantEndDate)]
}

export const removeRepeatedChildEvents = (healthProcedures: IHealthProcedures[]): IHealthProcedures[] => {
  const healthProceduresWithoutRepeated = healthProcedures.filter((healthProcedure, index) => {
    const isRepeated = healthProcedures.findIndex(procedure => procedure.id === healthProcedure.id)
    return isRepeated === index
  })
  return healthProceduresWithoutRepeated
}

export const identifyDischargeNotebook = (healthProcedures: IHealthProcedures[]): IHealthProcedures[] => {
  const dischargeNotebookEvent = healthProcedures.find(
    event => event.type === EHealthProceduresTypes.MEDICAL_NOTE && event.description === 'Alta Médica'
  )
  const healthProceduresWithDischargeNotebook = healthProcedures.map(healthProcedure => {
    const isDischargeNotebook = healthProcedure.id === dischargeNotebookEvent?.id
    return isDischargeNotebook ? { ...healthProcedure, description: 'Caderno de Alta' } : healthProcedure
  })
  return healthProceduresWithDischargeNotebook
}

export const identifyBirthEventBasedOn =
  (gestation: IPregnancy) =>
  (healthProcedures: IHealthProcedures[]): ITimelineMaternalInfant.IHealthProcedures[] => {
    const withIdentifiedBirthAdmission = healthProcedures.map(healthProcedure => {
      const isAdmission = healthProcedure.type === EHealthProceduresTypes.ADMISSION

      if (isAdmission) {
        const admissionStartedAfterGestationEnd =
          getTimestamp(gestation.endDate) >= getTimestamp(healthProcedure.startDate)
        const admissionEndBeforeGestationEnd = getTimestamp(gestation.endDate) <= getTimestamp(healthProcedure.endDate)
        const isBirthAdmission = admissionStartedAfterGestationEnd && admissionEndBeforeGestationEnd

        return isBirthAdmission
          ? { ...healthProcedure, isBirthAdmission: true, birthDate: gestation.endDate }
          : healthProcedure
      }

      return healthProcedure
    })

    return withIdentifiedBirthAdmission
  }

export const isPregnant = (gestation: IPregnancy): boolean => {
  const today = new Date().getTime()
  const endDate = new Date(gestation.endDate)
  const gestationEndDate = new Date(endDate).getTime()
  return today <= gestationEndDate
}

export const isPuerperalPeriod = (gestation: IPregnancy): boolean => {
  const today = new Date().getTime()
  const endDate = new Date(gestation.endDate)
  const puerperalEndDate = new Date(endDate).setDate(endDate.getDate() + 60)
  return today <= puerperalEndDate
}

export const motherGestationDevelopmentStageLabel = (gestation: IPregnancy): string => {
  if (isPregnant(gestation)) return message('maternalInfant.pregnant')
  return message('maternalInfant.mother')
}

export const babyGestationDevelopmentStageLabel = (gestation: IPregnancy): string => {
  const gestationHasBabies = gestation.children?.length > 0

  const today = new Date().getTime()
  const endDate = new Date(gestation.endDate)
  const gestationEndDate = new Date(endDate).getTime()

  if (today < gestationEndDate) {
    return message('maternalInfant.fetus')
  }

  if (gestationHasBabies) {
    return message('maternalInfant.child')
  }

  return 'N/A'
}
